import { CommunityInput } from './community-input.model';

/**
 * Where a member works on their delivery from an input: the existing insight editor, with the
 * languages its route reads, the video screen, or the feature-review screen.
 */
export function workRouteFor(input: CommunityInput): { commands: string[]; queryParams: Record<string, string> } | null {
  const delivery = input.myDelivery;

  if (!delivery) {
    return null;
  }

  if (input.kind === 'insight_writing') {
    if (!delivery.insightSlug) {
      return null;
    }

    const queryParams: Record<string, string> = {};
    if (delivery.sourceLang) {
      queryParams['source_lang'] = delivery.sourceLang;
    }
    if (delivery.targetLang) {
      queryParams['target_lang'] = delivery.targetLang;
    }

    return { commands: ['/contributions/insights/create', delivery.insightSlug], queryParams };
  }

  if (input.kind === 'video_recording') {
    return { commands: ['/contributions/inputs', input.slug, 'video'], queryParams: { delivery: String(delivery.id) } };
  }

  return { commands: ['/contributions/inputs', input.slug, 'review'], queryParams: {} };
}
